import { reactive } from 'vue'
import { apiFetch } from './api'

export interface WarehouseItem {
  id: string
  code: string
  name: string
  category: string
  quantityTotal: number
  quantityMin: number
  location: string
  conditionStatus: string
  photoDataUrl: string
  unitValue: number
  reservedQuantity: number
  availableQuantity: number
}

function asRecord(value: unknown): Record<string, unknown> {
  return value && typeof value === 'object' ? (value as Record<string, unknown>) : {}
}

function mapItem(value: unknown): WarehouseItem {
  const row = asRecord(value)
  return {
    id: String(row.id || ''),
    code: String(row.code || ''),
    name: String(row.name || ''),
    category: String(row.category || ''),
    quantityTotal: Number(row.quantityTotal || 0),
    quantityMin: Number(row.quantityMin || 0),
    location: String(row.location || ''),
    conditionStatus: String(row.conditionStatus || 'bom'),
    photoDataUrl: String(row.photoDataUrl || ''),
    unitValue: Number(row.unitValue || 0),
    reservedQuantity: Number(row.reservedQuantity || 0),
    availableQuantity: Number(row.availableQuantity || 0)
  }
}

const state = reactive({
  items: [] as WarehouseItem[]
})

export const warehouseStore = {
  state,
  all() {
    return state.items
  },
  async refresh() {
    const rows = await apiFetch<unknown[]>('/warehouse/items')
    state.items = rows.map(mapItem)
    return state.items
  },
  async upsert(payload: Partial<WarehouseItem> & { code: string; name: string }) {
    await apiFetch<{ ok: boolean; id: string }>('/warehouse/items', {
      method: 'POST',
      body: JSON.stringify(payload)
    })
    await this.refresh()
  }
}
